import { Slide } from "@/@types/index"
import { SlideResponse } from '../slider/models/SlideResponse';

export function mapSlider(slide: SlideResponse): Slide {
  return {

    image: slide.image,
    image_responsive: slide.image_responsive,
    alt_text: slide.alt_text,
    link: slide.link,
    is_blank: slide.is_blank,
    order: slide.order,
  }
} 